export const useQuery = () => {
  // eslint-disable-next-line no-restricted-globals
  return new URLSearchParams(location.search);
};
